module.exports = __webpack_public_path__ + "img/ferie2_auto_approve.2ae88dc2.png";